import { render, staticRenderFns } from "./ConsultingDetail.vue?vue&type=template&id=cc84115a"
import script from "./ConsultingDetail.vue?vue&type=script&lang=js"
export * from "./ConsultingDetail.vue?vue&type=script&lang=js"
import style0 from "./ConsultingDetail.vue?vue&type=style&index=0&id=cc84115a&prod&lang=scss"
import style1 from "./ConsultingDetail.vue?vue&type=style&index=1&id=cc84115a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports